import { formatDistance } from 'date-fns';
import React from 'react';

export function TimeAgo({ iso }: { iso: string }) {
  if (iso == null) return null;
  const timeAgo = formatDistance(new Date(iso), new Date(), { addSuffix: true });
  return <>{timeAgo[0].toUpperCase() + timeAgo.slice(1)}</>;
}
